import script from "./CompanyProductEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProductEditView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProductEditView.vue?vue&type=style&index=0&id=3bc5d156&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc5d156"]])

export default __exports__